import { createStore } from 'satcheljs';
export default createStore('safeMailingListsOption', {
    safeMailingLists: null,
})();
//# sourceMappingURL=store.js.map